import React from "react";
import { NgcApiKeyDeployWithoutKeyConfirmation } from "../configuration/ngc-api-key/NgcApiKeyDeployWithoutKeyConfirmation";
import { orderLaunchableParametersForPresentation } from "../configuration/parameters/LaunchableParameters";
import { getComputeHardwareSummary } from "../configuration/compute/computeSummary";
import { useLaunchableDeployment } from "../hooks/useLaunchableDeployment";

interface LaunchableDeploymentConfirmationProps {
  onShowEditComputeModal?: () => void;
}

export const LaunchableDeploymentConfirmation: React.FC<
  LaunchableDeploymentConfirmationProps
> = ({ onShowEditComputeModal = () => {} }) => {
  const deployment = useLaunchableDeployment();

  return (
    <NgcApiKeyDeployWithoutKeyConfirmation
      open={deployment.ngcApiKey.isDeployWithoutNgcApiKeyConfirmationOpen}
      onOpenChange={deployment.handleConfirmationOpenChange}
      steps={deployment.confirmationSteps}
      stepIndex={deployment.confirmationStepIndex}
      computeHasErrors={deployment.computeHasErrors}
      computeIsOutOfStock={
        deployment.selectedInstanceIsOutOfStock ||
        deployment.isInstanceOutOfStock
      }
      selectedCompute={
        deployment.instanceType
          ? {
              details: getComputeHardwareSummary(deployment.instanceType),
              providerName: deployment.providerName,
              highlightFirstDetail: Boolean(
                deployment.instanceType.supported_gpus?.[0],
              ),
            }
          : null
      }
      onSelectCompute={onShowEditComputeModal}
      onNextStep={deployment.handleNextConfirmationStep}
      onConfirmDeploy={deployment.handleConfirmDeploy}
      onIncludeNgcApiKeyAndDeploy={deployment.handleIncludeNgcApiKeyAndDeploy}
      parameters={orderLaunchableParametersForPresentation(
        deployment.parameters,
      )}
      parameterValues={deployment.parameterValues}
      onParameterValuesChange={deployment.updateParameterValues}
      parameterSecretSelections={deployment.parameterSecretSelections}
      onParameterSecretSelectionsChange={
        deployment.managedSecretsEnabled
          ? deployment.updateParameterSecretSelections
          : undefined
      }
      availableSecrets={deployment.availableSecrets}
      secretsLoading={deployment.secretsLoading}
      organizationId={deployment.organizationId}
      hasMissingRequiredParameters={deployment.parametersHaveErrors}
    />
  );
};
